import type { AxiosResponse } from 'axios'
import type { components } from 'schema.ts'

import { getFilenameFromHeaders } from '~/portal/api/api.helpers.ts'
import type { IFetchApiProps } from '~/portal/api/axios.ts'
import { FETCH_API_METHODS, fetchApi } from '~/portal/api/axios.ts'
import { STATE_STORE_KEYS } from '~/portal/types'

export interface IFetchApiExportProtector {
	token: IFetchApiProps['token']
	id: number
}

export interface IFetchApiExportProtectorTemplate {
	token: IFetchApiProps['token']
}

export interface IFetchApiProtectorList {
	token: IFetchApiProps['token']
	projectId?: number
	params?: { page?: number; return_all?: boolean }
}
export interface IFetchApiFindProterctor {
	token: IFetchApiProps['token']
	projectId: number
	payload: components['schemas']['FindProjectProtector']
}
export interface IFetchApiDeleteProtector {
	token: IFetchApiProps['token']
	projectId: number
	protectorId: number
}
export interface IFetchApiProtectorTypeList {
	token: IFetchApiProps['token']
	params?: { page?: number; return_all?: boolean; type?: string }
}

export interface IFetchApiDeleteProtectorDB {
	token: IFetchApiProps['token']
	id: number
}
export const fetchApiDeleteProtectorDB = async ({
	token,
	id
}: IFetchApiDeleteProtectorDB) => {
	return fetchApi({
		url: `/product/protector/${id}/delete`,
		method: FETCH_API_METHODS.Delete,
		token,
		pendingKey: STATE_STORE_KEYS.ProtectorDelete
	})
}

export const fetchApiProtectorList = async ({
	token,
	projectId,
	params
}: IFetchApiProtectorList) => {
	const response = await fetchApi({
		token,
		method: FETCH_API_METHODS.Get,
		pendingKey: STATE_STORE_KEYS.ProtectorList,
		url: `/project/${projectId}/protector/list`,
		params
	})
	if (response?.data) return response.data
}
export const fetchApiFindProtector = async ({
	token,
	projectId,
	payload
}: IFetchApiFindProterctor) => {
	return fetchApi({
		token,
		method: FETCH_API_METHODS.Post,
		pendingKey: STATE_STORE_KEYS.ProtectorFind,
		url: `/project/${projectId}/protector/find`,
		payload
	})
}
export const fetchApiDeleteProtector = async ({
	token,
	projectId,
	protectorId
}: IFetchApiDeleteProtector) => {
	return fetchApi({
		token,
		method: FETCH_API_METHODS.Delete,
		pendingKey: STATE_STORE_KEYS.ProtectorDelete,
		url: `/project/${projectId}/protector/${protectorId}/delete`
	})
}
export interface IFetchApiProtectorTypeList2 {
	token: IFetchApiProps['token']
	params?: { page?: number; return_all?: boolean }
}
export const fetchApiProtectorTypeList = async ({
	token,
	params
}: IFetchApiProtectorTypeList) => {
	const response = await fetchApi({
		token,
		method: FETCH_API_METHODS.Get,
		pendingKey: STATE_STORE_KEYS.ProtectorTypeList,
		url: '/product/type/list',
		params: { ...params, return_all: true }
	})
	if (response?.data) return response.data
}
export interface IFetchAPIProtectorCompanyList {
	token: IFetchApiProps['token']
	params?: {
		search?: string
		type_id?: string | number
		page?: number
		page_size?: number
	}
}
export const fetchAPIProtectorCompanyList = async (
	payload: IFetchAPIProtectorCompanyList
) => {
	const response = await fetchApi({
		url: '/product/protector/list',
		token: payload.token,
		method: FETCH_API_METHODS.Get,
		pendingKey: STATE_STORE_KEYS.ProtectorCompanyList,
		params: payload.params
	})
	if (response?.data) return response.data
}

export const fetchApiExportProtector = async ({
	token,
	id
}: IFetchApiExportProtector): Promise<{
	blob: Blob
	filename: string | null
}> => {
	const url = `/product/protector/${id}/export`
	const resp = (await fetchApi({
		url,
		method: FETCH_API_METHODS.Get,
		token,
		pendingKey: STATE_STORE_KEYS.ProtectorExport,
		responseType: 'blob'
	})) as AxiosResponse<Blob>

	const filename = getFilenameFromHeaders(
		resp.headers,
		url,
		`protector-${id}.xlsx`
	)
	return { blob: resp.data, filename }
}

export const fetchApiExportProtectorTemplate = async ({
	token
}: IFetchApiExportProtectorTemplate): Promise<{
	blob: Blob
	filename: string | null
}> => {
	const url = '/product/protector/export/template'
	const resp = (await fetchApi({
		url,
		method: FETCH_API_METHODS.Get,
		token,
		pendingKey: STATE_STORE_KEYS.ProtectorExportAll,
		responseType: 'blob'
	})) as AxiosResponse<Blob>

	const filename = getFilenameFromHeaders(
		resp.headers,
		url,
		'protectors-template.xlsx'
	)
	return { blob: resp.data, filename }
}
